import React, { useEffect, useState } from "react";
import { PageContextUtils, StoreUtils } from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { UserContextSelectors } from "../../../../redux/selectors";
import { LocalizationMessages } from "../../../../localization/messages";
import { FormattedMessage, useIntl } from "react-intl";
import { Channel, DialogType, Topic } from "../../../../constants";
import { MessageBrokerUtils, TrackingUtils } from "../../../../utils";
import {
  MyAccountAreaFooterWrapper,
  AppVersion,
  LogoutButton,
  Separator
} from "./myAccountAreaFooterWrapper";
import { AccountActionCreators } from "../../../../redux/action-creators";
import { useFeature } from "../../../../hooks/useFeature";
import { AppFeatures } from "../../../../constants/featureFlags";
import { TrackingInfo } from "../../../tracking/TrackingInfoMyAccountArea";
const MyAccountAreaFooter = () => {
  const isNative = useSelector(UserContextSelectors.isNative);
  const isLugasLogoutActive = useFeature(AppFeatures.LUGAS_LOGOUT);

  const { clientVersion } = PageContextUtils.getDeviceData();
  const { clientLangIso3 } = PageContextUtils.getLocalizationData();
  const { versionNumber } = PageContextUtils.getReleaseData();
  const nativeVersion = StoreUtils.getNativeDataStoreItem("Version");
  const [appVersion, setAppVersion] = useState("");

  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  useEffect(() => {
    let appVerBuilder = `${formatMessage(
      LocalizationMessages.AppVersion
    )} ${clientVersion}-${clientLangIso3?.toUpperCase()}-${versionNumber}`;
    if (isNative) appVerBuilder += `-${nativeVersion}`;
    setAppVersion(appVerBuilder);
  }, [
    clientVersion,
    formatMessage,
    isNative,
    clientLangIso3,
    nativeVersion,
    versionNumber
  ]);

  const logout = async () => {
    dispatch(AccountActionCreators.toggleAccountDrawer());

    TrackingUtils.sendAnalytics({
      ...TrackingInfo,
      dataLabel: "Logout"
    });

    if (isLugasLogoutActive) {
      MessageBrokerUtils.publish({
        channel: Channel.UI,
        topic: Topic.Dialog,
        headers: {
          publisher: "UAA"
        },
        data: { dialogType: DialogType.LugasLogout }
      });
    } else {
      MessageBrokerUtils.publish({
        channel: Channel.UI,
        topic: Topic.Dialog,
        headers: {
          publisher: "UAA"
        },
        data: { dialogType: DialogType.Logout }
      });
    }
  };

  return (
    <MyAccountAreaFooterWrapper>
      <AppVersion data-testid="uc-my-account-area-footer-app-version">
        {appVersion}
      </AppVersion>
      <Separator />
      <LogoutButton
        onClick={logout}
        data-testid="uc-my-account-area-footer-logout"
      >
        <FormattedMessage {...LocalizationMessages.logoutText} />
      </LogoutButton>
    </MyAccountAreaFooterWrapper>
  );
};

export default React.memo(MyAccountAreaFooter);
